import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["steps", "step", "display", "template"]
  static values = { ratio: Number, updateUrl: String, addUrl: String }

  connect() {
    this.boundUpdate = this.updateDisplay.bind(this)
    this.refreshInputs()
    this.updateNames()
    this.updateDisplay()
  }

  disconnect() {
    this.stepTargets.forEach((step) => {
      const input = step.querySelector('input[type="number"]')
      if (input) input.removeEventListener('input', this.boundUpdate)
    })
  }

  refreshInputs() {
    this.stepTargets.forEach((step) => {
      const input = step.querySelector('input[type="number"]')
      if (input && !input.dataset.listener) {
        input.addEventListener('input', this.boundUpdate)
        input.dataset.listener = "true"
      }
    })
    this.updateNames()
  }


  updateDisplay() {
    this.displayTargets.forEach((d) => (d.textContent = ""))
    const firstStep = this.stepsTarget.querySelector('[data-collect-steps-target="step"]')
    if (!firstStep) return

    const input = firstStep.querySelector('input[type="number"]')
    const value = parseFloat(input.value || 0)
    const amount = Math.round(value * (this.ratioValue || 0))
    const formatted = new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0
    }).format(amount)
    const percent = Math.round((this.ratioValue || 0) * 100)
    const display = firstStep.querySelector('[data-collect-steps-target="display"]')
    if (display) display.textContent = `${percent}% = ${formatted}`
  }

  save(event) {
    event.preventDefault()
    const formData = new FormData(this.element)
    fetch(this.updateUrlValue, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': this.csrfToken()
      },
      body: formData
    })
      .then((r) => r.json())
      .then((data) => {
        this.reorder(data.steps)
        this.updateDisplay()
        this.showNotice(data.notice)
      })
      .catch((e) => console.error(e))
  }

  add() {
    fetch(this.addUrlValue, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': this.csrfToken()
      }
    })
      .then((r) => r.json())
      .then((data) => {
        const template = this.stepTargets[0] || this.templateTarget.content.firstElementChild
        const clone = template.cloneNode(true)
        clone.id = `collect_step_${data.id}`
        clone.querySelector('input[name$="[id]"]').value = data.id
        const input = clone.querySelector('input[type="number"]')
        input.value = data.amount
        const btn = clone.querySelector('[data-action="collect-steps#delete"]')
        btn.dataset.collectStepsUrlValue = data.destroy_path
        btn.dataset.collectStepId = data.id
        this.stepsTarget.appendChild(clone)
        this.refreshInputs()
        input.focus()
        this.updateDisplay()
        this.showNotice(data.notice)
      })
      .catch((e) => console.error(e))
  }

  delete(event) {
    const url = event.currentTarget.dataset.collectStepsUrlValue
    const stepId = event.currentTarget.dataset.collectStepId
    if (!confirm('Êtes-vous sûr de vouloir supprimer cette étape ?')) return
    fetch(url, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': this.csrfToken(),
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then((r) => r.json())
      .then((data) => {
        const step = document.getElementById(`collect_step_${stepId}`)
        if (step) step.remove()
        this.refreshInputs()
        this.updateDisplay()
        this.showNotice(data.notice)
      })
      .catch((e) => console.error(e))
  }

  reorder(steps) {
    if (!steps) return
    steps.forEach((step) => {
      const el = document.getElementById(`collect_step_${step.id}`)
      if (el) {
        this.stepsTarget.appendChild(el)
        const input = el.querySelector('input[type="number"]')
        if (input) input.value = step.amount
      }
    })
    this.refreshInputs()
  }

  showNotice(message) {
    if (!message) return
    const container = document.getElementById('flash_messages')
    if (!container) return
    container.innerHTML = `
      <div class="fixed inset-x-0 top-0 flex items-end justify-right px-4 py-6 sm:p-6 justify-end z-50 pointer-events-none">
        <div data-controller="alert" data-alert-dismiss-after-value="3000" class="max-w-sm w-full shadow-lg rounded-sm px-4 py-3 rounded relative border-l-4 text-white pointer-events-auto bg-emerald-500 border-emerald-700">
          <div class="p-2">
            <div class="flex items-start">
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-sm leading-5 font-medium">${message}</p>
              </div>
              <div class="ml-4 flex-shrink-0 flex">
                <button data-action="alert#close" class="inline-flex text-white focus:outline-none focus:text-gray-300 transition ease-in-out duration-150">
                  <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>`
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]').content
  }

  updateNames() {
    this.stepTargets.forEach((step) => {
      const idInput = step.querySelector('input[name$="[id]"]')
      const amountInput = step.querySelector('input[type="number"]')
      if (!idInput) return
      const id = idInput.value
      const prefix = 'collect[collect_steps_attributes]'
      idInput.name = `${prefix}[${id}][id]`
      if (amountInput) amountInput.name = `${prefix}[${id}][amount]`
    })
  }
}
